import type { ToolCallApproval } from '@/components/assistant-ui/tool-status';
import {
  CANCELLED_BY_SEND,
  EXPIRED_APPROVAL_REASON,
  isUnansweredApproval,
  SUPERSEDED_APPROVAL_REASON,
} from '@/lib/constants/tool-outcomes';

export interface ApprovalPartState extends ToolCallApproval {
  readonly id: string;
  readonly isAutomatic?: boolean;
}

export type ApprovalCardState =
  'pending' | 'approved' | 'auto-approved' | 'denied' | 'expired' | 'cancelled' | 'unanswered';

export function resolveApprovalCardState(approval: Partial<ApprovalPartState>): ApprovalCardState {
  if (isUnansweredApproval(approval)) return 'unanswered';
  if (approval.approved === false && approval.reason === CANCELLED_BY_SEND) return 'cancelled';
  if (approval.resolution) return approval.resolution;
  if (approval.approved === false && approval.reason === EXPIRED_APPROVAL_REASON) return 'expired';
  if (approval.approved === true) return approval.isAutomatic ? 'auto-approved' : 'approved';
  if (approval.approved === false) return 'denied';
  return 'pending';
}

/** Still waiting on the guest: not answered, resolved, cancelled or left unanswered. */
export function isApprovalPending(approval: Partial<ApprovalPartState>): boolean {
  return resolveApprovalCardState(approval) === 'pending';
}

/** A decline the guest never gave: they moved on instead, and the backend closed the gate. */
export function isSupersededApproval(approval: ApprovalPartState): boolean {
  return (
    resolveApprovalCardState(approval) === 'denied' &&
    approval.reason === SUPERSEDED_APPROVAL_REASON
  );
}
